import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import Modal from 'components/ui/Modal';
import AlertBox from 'components/ui/AlertBox';
import Seat from 'components/ui/SeatMapLegend/Seat';
import { LegendContainer, LegendItem, LegendLabel } from 'components/ui/SeatMapLegend/SeatMapLegend.styles';
import {
  StyledTabContainer,
  StyledTab,
  LegRoute,
  LegRouteOrigin,
  LegRouteDestination,
  LegDate,
  LegTime
} from 'components/shared/SeatSelection/SeatSelection.styles';
import serviceTypeCodes from 'constants/serviceTypeCodes';
import { legShape } from 'constants/propTypes';

import TrainOccupancy from './TrainOccupancy';
import { StyledAlertBox } from './TrainOccupancyModal.styles';

const TrainOccupancyModal = ({ isOpen, onClose, legs, shouldFetchAssistancesPerCoaches = false }) => {
  const [selectedServiceName, setSelectedServiceName] = useState(legs[0].serviceName);
  const selectedLeg = legs.find(({ serviceName }) => serviceName === selectedServiceName);
  const isERTrain = selectedLeg.serviceType.code === serviceTypeCodes.GREENSPEED;

  return (
    <Modal isOpen={isOpen} onClose={onClose} minWidth="min(1400px, calc(100vw - 120px))">
      <StyledTabContainer data-testid="train-occupancy-tabs" selectedIdIsGreenspeedTrain={isERTrain}>
        {legs.map(({ serviceName, origin, destination, timing: { departureDate, departs } }) => (
          <StyledTab
            type="button"
            key={serviceName}
            selected={serviceName === selectedServiceName}
            onClick={() => setSelectedServiceName(serviceName)}
            data-testid={`train-occupancy-tab_${serviceName}`}
            data-selected={serviceName === selectedServiceName}
            selectedIdIsGreenspeedTrain={isERTrain}
          >
            <LegRoute>
              <LegRouteOrigin>{origin.shortCode}</LegRouteOrigin>
              <LegRouteDestination>{destination.shortCode}</LegRouteDestination>
            </LegRoute>
            <LegDate>
              {moment.utc(departureDate).format('DD MMM YYYY')} <LegTime>at {departs}</LegTime>
            </LegDate>
          </StyledTab>
        ))}
      </StyledTabContainer>
      <StyledAlertBox variant={AlertBox.variants.INFO} dataCy="train-occupancy-info">
        <div>
          <FormattedMessage id="searchResults.trainOccupancy.mapInfo" />
        </div>
        <div>
          <FormattedMessage id="searchResults.trainOccupancy.ticketAvailability" />
        </div>
      </StyledAlertBox>
      <TrainOccupancy key={selectedServiceName} leg={selectedLeg} shouldFetchAssistancesPerCoaches={shouldFetchAssistancesPerCoaches} />
      <LegendContainer data-testid="train-occupancy-legend">
        <LegendItem>
          <Seat isErSeat={isERTrain} /> - <FormattedMessage id="seatMapLegend.available" />
        </LegendItem>
        <LegendItem>
          <Seat isErSeat={isERTrain} dataStatus="unavailable" /> - <FormattedMessage id="seatMapLegend.unavailable" />
        </LegendItem>
        <LegendItem>
          <LegendLabel>P</LegendLabel> - <FormattedMessage id="seatMapLegend.prioritySeat" />
        </LegendItem>
      </LegendContainer>
    </Modal>
  );
};

TrainOccupancyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  legs: PropTypes.arrayOf(legShape).isRequired,
  shouldFetchAssistancesPerCoaches: PropTypes.bool
};

export default TrainOccupancyModal;
